module.exports = __webpack_public_path__ + "static/media/icons-ic-inbound-call-stroke.0a9557ff.svg";